if (!customElements.get("product-delivery")) {
  class ProductDelivery extends HTMLElement {
    static eventListenersAdded = false;

    constructor() {
      super();
      this.initLazySection();
    }

    initLazySection() {
      // Add one-time listener for 'variantChange'
      if (!ProductDelivery.eventListenersAdded) {
        this.addEventListener("variantChange", this.variantChange.bind(this));
        ProductDelivery.eventListenersAdded = true;
      }

      // Get all variant data from #variant-data script
      this.variantInventory = this.getVariantInventory();

      // Use data-id to find the initial variant
      const initialVariant = this.variantInventory.find(
        (v) => v.id == this.dataset.id
      );
      if (initialVariant) {
        this.updateDisplay();
      }
    }

    variantChange(event) {
      if (!event.detail?.variant) return;
      this.dataset.id = event.detail.variant.id;

      // Find updated variant in our inventory array
      const updatedVariant = this.variantInventory.find(
        (v) => v.id === event.detail.variant.id
      );
      if (updatedVariant?.available) {
        this.updateDisplay();
      }
    }

    // A single method to handle stock display & show/hide logic
    updateDisplay() {
      const availableVariants = this.variantInventory.filter(
        (variant) => variant.available
      );
      const allAvailableVariantsHaveWarehouseStock = availableVariants.length > 0
        && availableVariants.every((variant) => Number(variant.warehouse) > 0);

      // Only hide handling-time messaging when every available variant has warehouse stock.
      document
        .querySelectorAll(".delivery-sec-stock.delivery-subtitle")
        .forEach((el) => {
          el.style.display = allAvailableVariantsHaveWarehouseStock ? "none" : "block";
        });

      // Show the no-handling-time messaging only when every available variant has warehouse stock.
      document
        .querySelectorAll(".delivery-main-stock.delivery-subtitle")
        .forEach((el) => {
          el.style.display = allAvailableVariantsHaveWarehouseStock ? "block" : "none";
        });
    }

    // Pulls variant data from <script id="variant-data" type="application/json">
    getVariantInventory() {
      const dataEl = document.querySelector("#variant-data");
      if (!dataEl) return [];
      return JSON.parse(dataEl.textContent);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("product-delivery")) {
      customElements.define("product-delivery", ProductDelivery);
    }
  });
}
